import { createAction, props } from "@ngrx/store";
import { Claim } from "src/app/core/models/claim";

export const clearClaims = createAction("[Claims] Clear Claims");

export const setClaims = createAction(
  "[Claims] Set Claims",
  props<{
    claims: Claim[];
  }>()
);